import { render, staticRenderFns } from "./waterMark.vue?vue&type=template&id=755eb08a&"
import script from "./waterMark.vue?vue&type=script&lang=js&"
export * from "./waterMark.vue?vue&type=script&lang=js&"
import style0 from "./waterMark.vue?vue&type=style&index=0&id=755eb08a&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports